import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children, withFooter = true }) {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground grain">
            <Navbar />
            <main className="flex-1 relative z-10">{children}</main>
            {withFooter && <Footer />}
        </div>
    );
}
